var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.511,
    height: 20.436,
    viewBox: "0 0 20.511 20.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-pop-out-1406946",
    transform: "translate(-110.396 -114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_5175",
    "data-name": "path 5175",
    d: "M492.973,114.754v-.176l-.05-.1-.05-.075-.126-.151-.2-.151-.075-.05-.1-.05h-5.832a1.005,1.005,0,1,0,0,2.011h3.016l-9.024,8.948a1.013,1.013,0,0,0,1.433,1.433l9.024-9.024v3.016a1.005,1.005,0,1,0,2.011,0V114.93a1.006,1.006,0,0,0-.025-.176Z",
    transform: "translate(-362.091)",
    fill: "#19c180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_5176",
    "data-name": "path 5176",
    d: "M113.412,250.747h11.915a3.016,3.016,0,0,0,3.016-3.016v-7.114a1.005,1.005,0,1,0-2.011,0v7.114a1.005,1.005,0,0,1-1.005,1.005H113.412a1.005,1.005,0,0,1-1.005-1.005V235.816a1.005,1.005,0,0,1,1.005-1.005h7.114a1.005,1.005,0,1,0,0-2.011h-7.114a3.016,3.016,0,0,0-3.016,3.016v11.915a3.017,3.017,0,0,0,3.016,3.016Z",
    transform: "translate(0 -116.311)",
    fill: "#19c180"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopOut);
export default __webpack_public_path__ + "static/media/popOut.330d9b130772023ad84d65dae6f72ad8.svg";
export { ForwardRef as ReactComponent };